// src/features/security/components/SecurityStatusBadge.tsx
import type { SecurityStatus } from '../data/security.mock';

export interface SecurityStatusBadgeProps {
  status: SecurityStatus;
}

const STATUS_LABEL: Record<SecurityStatus, string> = {
  active: 'فعال',
  disabled: 'غیرفعال',
  warning: 'هشدار',
};

const STATUS_COLOR_VAR: Record<SecurityStatus, string> = {
  active: 'var(--vania-accent-teal, #2fd6a7)',
  disabled: 'var(--vania-accent-rose, #ff6b81)',
  warning: 'var(--vania-accent-amber, #f5b942)',
};

/**
 * Small pill badge mapping a security module's raw status to its
 * Persian label + accent color. Same status-badge shape used by
 * commission/components/CommissionStatusBadge.tsx and
 * users/components/UserStatusBadge.tsx (label map + color-var map
 * keyed by the union type) — kept local to this feature since the
 * union (active/disabled/warning) is security-specific.
 */
export function SecurityStatusBadge({ status }: SecurityStatusBadgeProps) {
  const color = STATUS_COLOR_VAR[status];

  return (
    <span className="vania-security-status-badge" style={{ color, borderColor: color }}>
      <span aria-hidden className="vania-security-status-dot" style={{ backgroundColor: color }} />
      {STATUS_LABEL[status]}
    </span>
  );
}
